// import firebase from 'firebase'
// import firestore from 'firebase/firestore'

// Initialize Firebase
export const config = {
  apiKey: "AIzaSyDTPOrJwFArb4vX5JthAb2zPmpYIuD91Wo",
  authDomain: "prudentcpa-com.firebaseapp.com",
  databaseURL: "https://prudentcpa-com.firebaseio.com",
  projectId: "prudentcpa-com",
  storageBucket: "prudentcpa-com.appspot.com",
  messagingSenderId: "869009159556"
};

// const firebaseApp = firebase.initializeApp(config);
// firebaseApp.firestore().settings({ timestampsInSnapshots: true });

// export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js